import { render, staticRenderFns } from "./TelegramOtpDetailInfo.vue?vue&type=template&id=05373364&"
import script from "./TelegramOtpDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./TelegramOtpDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports